import actionTypes from './constants';

/* */
export const update = (data) => (dispatch) => dispatch({
    payload: data,
    type: actionTypes.UPDATE,
  });

/* */
export const addProductToCart = (product) => (dispatch) => dispatch({
    payload: product,
    type: actionTypes.ADD_PRODUCT_TO_CART,
  });

/* */
export const addTransaction = (transaction) => (dispatch) => dispatch({
    payload: transaction,
    type: actionTypes.ADD_TRANSACTION,
  });
